import { Box } from "@mui/material";
import { CellValueChangedEvent, GetRowIdParams } from "ag-grid-community";
import { useState } from "react";
import { IFormGrid } from "../../../services/custom-forms-data-service/TemplateModels";
import { IFormInstanceData } from "../../../views/object-form-view/Models";
import { NumericCellEditor } from "../../ag-grid-extensions/cell-editors/NumericCellEditor";
import CheckboxCellRenderer from "../../ag-grid-extensions/renderers/CheckboxCellRenderer";
import { CustomFormRunnerModeType } from "../CustomFormRunner";
import CustomFormGridUtils from "./CustomFormGridUtils";
import DefaultGrid from "../../default-grid/DefaultGrid";
import { AutoSizeStrategyEnum } from "../../default-grid/InternalGrid";

export type CustomFormGridProps = {
    mode?: CustomFormRunnerModeType,
    grid: IFormGrid;
    instanceData?: IFormInstanceData;
    onDataChanged: (event: CellValueChangedEvent) => void;
    key?: React.Key | null | undefined
};

export default function CustomFormGrid({
    mode,
    key,
    grid,
    instanceData,
    onDataChanged

}: CustomFormGridProps) {


    const [columns] = useState(CustomFormGridUtils.createColumns(grid, mode));
    const [rows] = useState(CustomFormGridUtils.createRows(grid, instanceData))
    //const columns = CustomFormGridUtils.createColumns(grid, mode);
    //const rows = CustomFormGridUtils.createRows(grid, instanceData);

    return (

        <Box key={key}
            sx={{display: "flex",
               flexDirection: "column",
               flexGrow: 1,
               flexShrink: 0,
               flexBasis: '100%'
               //overflow: "hidden",
           }}>

            <DefaultGrid
                //onGridReady={onGridReady}
                suppressMovableColumns={true}
                components={{
                    numericCellEditor: NumericCellEditor,
                    checkBoxCellRenderer: CheckboxCellRenderer
                }}
                rowData={rows}
                defaultColDef={{
                    sortable: false,
                    filter: "agMultiColumnFilter",
                    resizable: true,
                    editable: true,
                }}
                columnDefs={columns}
                //getRowNodeId={(data: any) => data.id}
                getRowId={(params: GetRowIdParams) => params.data?.id}                
                onCellValueChanged={onDataChanged}
                autoSizeStrategy={AutoSizeStrategyEnum.None}
            />

        </Box>


    );
}
